import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { SiteWorkOrdersService } from 'app/_services/site-work-orders.service';
import { NotificationService } from 'app/_services/notification.service';

@Component({
  selector: 'work-order-search-field',
  templateUrl: './work-order-search-field.component.html',
  styles: []
})
export class WorkOrderSearchFieldComponent implements OnInit {
  @Input() public site: any;
  @Input() public filterBySite: boolean = false;
  private routeRole: string;
  public searchTerm: string;

  constructor(
    private router: Router,
    private workOrderService: SiteWorkOrdersService,
    private notificationService: NotificationService,
    private globals: Globals,
  ) {
    this.routeRole = globals.user.routeRole;
  }

  ngOnInit() {
  }

  public search() {
    if (!this.searchTerm || !this.searchTerm.trim()) {
      this.notificationService.notify('warning', 'Empty field', 'Please enter a Work Order ID to search');
      return;
    }
      const formattedTerm = this.searchTerm.trim().replace(/\s/g, '');
      this.searchWorkOrdersById(formattedTerm);

  }

  private searchWorkOrdersById(formattedTerm: string) {

    this.workOrderService.getWorkOrderById(formattedTerm).subscribe(
      (data) => {
        const workOrderId = data.id;
        const workOrderSiteId = data.asset.site.id;

        if (this.filterBySite && this.site && workOrderSiteId !== this.site.id) {
          this.notificationService.notify(
            'warning',
            'Different Site',
            'This Work Order belongs to another site. Please check the Work Order ID'
          );
          return;
        }

        const url = `/${this.routeRole}/sites/${workOrderSiteId}/work-orders/${workOrderId}`;
        this.navigateTo(url);

      },
      (error) => {
        this.notificationService.notify('danger', 'Error', 'Work Order not found. Please check the Work Order ID');
      }
    )
  }

  private navigateTo(url: string) {
    this.router.navigateByUrl('/' + this.routeRole + '/work-orders', { skipLocationChange: true }).then(() => {
      this.router.navigate([url]);
      this.clearFilter();
    });
  }

  public clearFilter() {
    this.searchTerm = '';
  }

}

